import isEqual from 'lodash/isEqual';
import get from 'lodash/get';
import * as utils from './Utils';


export function formatCartItem(itemRow) {
  let productTitle = itemRow.name;
  let variantTitle = '';

  if (itemRow.options) {
    variantTitle = itemRow.options.map((option) => option.value).join("/") || '';
  }

  let item = {};
  item['id'] = `${itemRow.id}`;
  item['title'] = variantTitle ? `${productTitle} (${variantTitle})` : productTitle;
  item['quantity'] = itemRow.quantity;
  item['price'] = itemRow.salePrice;
  item['product_id'] = `${itemRow.productId}`;
  item['product_title'] = productTitle;
  item['variant_id'] = `${itemRow.variantId}`;
  item['variant_title'] = variantTitle;
  return item;
}

export function formatCartResponse(response) {
  if (!response.id) return {};

  let data = {};
  data['currency'] = response.currency.code;
  data['total_price'] = response.cartAmount;
  data['total_discount'] = response.discountAmount;

  let items = [];
  if (response.lineItems) {
    response.lineItems.physicalItems.forEach((itemRow) => {
      let item = formatCartItem(itemRow);
      items.push(item);
    })

    response.lineItems.digitalItems.forEach((itemRow) => {
      let item = formatCartItem(itemRow);
      items.push(item);
    })
  }

  data['items'] = items;
  return data;
}


function getAddedCartItems(response) {
  const existingData = get(window.OnVoardEventsData, 'bigcommerce_cart', {});

  const existingMapper = {};
  if (existingData.lineItems) {
    existingData.lineItems.physicalItems.forEach((itemRow) => {
      existingMapper[`${itemRow.id}`] = parseInt(itemRow.quantity);
    })

    existingData.lineItems.digitalItems.forEach((itemRow) => {
      existingMapper[`${itemRow.id}`] = parseInt(itemRow.quantity);
    })
  }

  const currentMapper = {};
  if (response.lineItems) {
    response.lineItems.physicalItems.forEach((itemRow) => {
      currentMapper[`${itemRow.id}`] = parseInt(itemRow.quantity);
    })

    response.lineItems.digitalItems.forEach((itemRow) => {
      currentMapper[`${itemRow.id}`] = parseInt(itemRow.quantity);
    })
  }

  let addedIds = utils.getAddedCartItemIds(existingMapper, currentMapper);
  let addedItems = [];
  if (response.lineItems) {
    response.lineItems.physicalItems.forEach((itemRow) => {
      let itemId = `${itemRow.id}`;
      if (!addedIds.includes(itemId)) return;
      addedItems.push(itemRow)
    })

    response.lineItems.digitalItems.forEach((itemRow) => {
      let itemId = `${itemRow.id}`;
      if (!addedIds.includes(itemId)) return;
      addedItems.push(itemRow)
    })
  }

  return addedItems;
}

export function handleCartUpdate(response) {
  let noChange = isEqual(window.OnVoardEventsData['bigcommerce_cart'], response);
  let isNew = !window.OnVoardEventsData['bigcommerce_cart'] ? true : false;

  // no cart change
  if (noChange) return;

  // if first time loading, don't dispatch added cart items
  let addedCartItems = [];
  if (!isNew) addedCartItems = getAddedCartItems(response);

  window.OnVoardEventsData['bigcommerce_cart'] = response;
  utils.dispatchCartUpdateEvent(response);
  addedCartItems.forEach((item) => {
    utils.dispatchAddCartItemEvent(item);
  })
}

export function setupCartUpdateEvent() {
  if (window.OnVoardEventsData.setupCartUpdateEvent) return;
  window.OnVoardEventsData.setupCartUpdateEvent = true;

  let cartUpdatePaths = [
    "/api/storefront/carts",
  ];

  utils.interceptRequests(cartUpdatePaths, (response, url) => {
    if (url.includes('items')) return;
    response = utils.parseResponse(response);
    if (!response) return;
    if (response.status === 'error') return;

    if (!utils.isArray(response)) {
      handleCartUpdate(response);
      return;
    }

    let cart = {};
    if (response && response.length > 0) cart = response[0];
    handleCartUpdate(cart);
  });

  const triggerPaths = [
    "/remote/v1/cart/add",
    "/remote/v1/cart/update",
  ];

  let triggerCartUpdate = () => {
    utils.getRq({
      "url": "/api/storefront/carts?include=lineItems.physicalItems.options,lineItems.digitalItems.options",
      "headers": {
        "x-requested-with": "XMLHttpRequest",
      },
      "successCallback": (response) => {
        response = utils.parseResponse(response);
        if (!response) return;
        if (response.status === 'error') return;

        let cart = {};
        if (response && response.length > 0) cart = response[0];
        handleCartUpdate(cart);
      },
      "errorCallback": () => {}
    });
  };

  utils.interceptRequests(triggerPaths, (response, url) => {
    triggerCartUpdate();
  });
}

export function loadCart() {
  let successCallback = (response) => {
    response = utils.parseResponse(response);
    if (!response) return;
    if (response.status === 'error') return;

    let cart = {};
    if (response && response.length > 0) cart = response[0];
    handleCartUpdate(cart);
  };

  let errorCallback = () => {};

  utils.getRq({
    "url": "/api/storefront/carts?include=lineItems.physicalItems.options,lineItems.digitalItems.options",
    "headers": {
      "x-requested-with": "XMLHttpRequest",
    },
    "successCallback": successCallback,
    "errorCallback": errorCallback,
  });
}

